import React, { useEffect, useState, useContext } from 'react'
import Button from '../formfields/Button'
import { GlobalContext } from '../GlobalContext'
import HeaderDetails from '../shared-components/HeaderDetails'
import Card from '../ui-elements/Card'
import Spinner from '../ui-elements/Spinner'
import ChecklistSummary from './ChecklistSummary'
import SummaryCheckWindow from './SummaryCheckWindow'
import { json } from 'stream/consumers'
import NoActiveCheckPeriods from './NoActiveCheckPeriods'
import NoChecklists from './NoChecklists'
import FilterChecklistCategories from './FilterChecklistCategories'
import { useSearchParams } from 'react-router-dom'
import ExpandCollapseIcon from '../ui-elements/ExpandCollapseIcon'
import RemindersPanel from './RemindersPanel/RemindersPanel'


type Props = {
  // activeChecklistIds: string[]
  // inActiveChecklistIds: string[]
  // checkPeriods: ObjectStringKeyAnyValue | null
}

function Dashboard({
  // activeChecklistIds,
  // inActiveChecklistIds
  // checkPeriods
}: Props) {

  const {
    tableData,
    currentOrganisation
  } = useContext(GlobalContext)


  const [searchParams] = useSearchParams()
  const [checkPeriodIdsInProgress, setCheckPeriodIdsInProgress] = useState<string[]>([])
  const [checkPeriodIdsComplete, setCheckPeriodIdsComplete] = useState<string[]>([])
  const [checklistIdsToDisplay, setChecklistIdsToDisplay] = useState<string[]>([])
  const [expandIncompleteChecklists, setExpandIncompleteChecklists] = useState<boolean>(true)
  const [expandCompleteChecklists, setExpandCompleteChecklists] = useState<boolean>(false)




  useEffect(() => {
    if (tableData && tableData.ChecklistPeriods && tableData.Checklists) {
      const newCheckPeriodIdsInProgress: string[] = []
      const newCheckPeriodIdsComplete: string[] = []

      // Sort checklist periods by start time in descending order
      const checkPeriodIdsSortedByStartTime = Object.keys(tableData.ChecklistPeriods).sort((a, b) => {
        const startTimeA = tableData.ChecklistPeriods[a].StartTimeStamp || ''
        const startTimeB = tableData.ChecklistPeriods[b].StartTimeStamp || ''
        return new Date(startTimeB).getTime() - new Date(startTimeA).getTime()
      })
      
      // divide into completed and imcomplete checklists
      checkPeriodIdsSortedByStartTime.forEach((checklistPeriodId: string) => {
        const thisChecklistPeriod = tableData.ChecklistPeriods[checklistPeriodId]
        const checklistId = thisChecklistPeriod.ChecklistId
        const thisChecklist = tableData.Checklists[checklistId] || null
        if (thisChecklist && checklistIdsToDisplay.includes(checklistId)) {
          //console.log('Checklist found for checklist period', checklistPeriodId)
          if (
            (thisChecklistPeriod.Progress &&
            thisChecklistPeriod.Progress.progress_percentage &&
            parseInt(`${thisChecklistPeriod.Progress.progress_percentage}`) === 100)
            || thisChecklistPeriod.InProgress !== 'True'
          ) {
            newCheckPeriodIdsComplete.push(checklistPeriodId)
          } else {
            newCheckPeriodIdsInProgress.push(checklistPeriodId)
          }
        } else {
          //console.log('No checklist found for checklist period', checklistPeriodId)
        }
      })
      setCheckPeriodIdsInProgress(newCheckPeriodIdsInProgress)
      setCheckPeriodIdsComplete(newCheckPeriodIdsComplete)
    }
  }, [tableData, checklistIdsToDisplay])

  useEffect(() => {
    filterChecklistCategories()
    redirectToLocallyStoredParams()
  }, [searchParams, tableData])


  const redirectToLocallyStoredParams = () => {
    console.log()
    const locallyStoredParams = localStorage.getItem(`checklistCategoryFilters-${currentOrganisation}`)
    const paramsFromUrl = searchParams.getAll('filter')
    // console.log('Params from URL:', paramsFromUrl)
    // console.log('Locally stored params:', locallyStoredParams)
    if (locallyStoredParams && paramsFromUrl.length === 0) {
      const params = JSON.parse(locallyStoredParams)
      //console.log('Locally stored params found', params)
      if (params && params.length > 0) {
        //console.log('Redirecting to locally stored params', params)
        const newSearchParams = new URLSearchParams()
        params.forEach((param: string) => {
          newSearchParams.append('filter', param)
        })
        window.location.search = newSearchParams.toString()
      }
    }
  }


  const filterChecklistCategories = () => {
    if (tableData && tableData.Checklists) {
      let filters = searchParams.getAll('filter')

      const checklistIdsSortedByChecklistName = tableData && tableData.Checklists && Object.keys(tableData.Checklists)
      checklistIdsSortedByChecklistName && checklistIdsSortedByChecklistName.sort((a: any, b: any) => {
        const checklistA = tableData.Checklists[a]
        const checklistB = tableData.Checklists[b]
        if (checklistA && checklistB && checklistA.ChecklistName && checklistB.ChecklistName) {
          return checklistA.ChecklistName.localeCompare(checklistB.ChecklistName)
        }
        return 0
      })

      if (filters.length > 0) {
        const newChecklistIdsToDisplay: string[] = []
        checklistIdsSortedByChecklistName.forEach((checklistId: string) => {
          const thisChecklist = tableData.Checklists[checklistId]
          const checklistCategories = thisChecklist['ChecklistCategories'] || []
          // check if any of the checklistCategories match any of the filters
          let anyMatches = false
          filters.forEach((filter) => {
            if (checklistCategories.includes(filter)) {
              anyMatches = true
            }
          })
          if (anyMatches) {
            newChecklistIdsToDisplay.push(checklistId)
          }
        })
        setChecklistIdsToDisplay(newChecklistIdsToDisplay)
      } else {
        setChecklistIdsToDisplay(checklistIdsSortedByChecklistName)
      }
    } else {
      //console.log('tabledata is empty')
    }
  }


  return <div className={`w-full flex-1 h-full flex flex-col items-center gap-2`}>

    <HeaderDetails
      titleText={'Checks due'}
    />


    <div className={`max-w-3xl w-full px-5 py-5 flex flex-col gap-4`}>


      <RemindersPanel />

      <FilterChecklistCategories redirectBaseUrl={'/'} />


      {tableData && tableData.Checklists && tableData.ChecklistPeriods ?
        <div className={`flex flex-col gap-4`}>
          {checklistIdsToDisplay.length > 0 ?
            <div className={`flex flex-row flex-wrap gap-6 text-xs`}>


              {checkPeriodIdsInProgress.length === 0 &&
                <NoActiveCheckPeriods />}

              {checkPeriodIdsInProgress.length > 0 &&
                <div className={`w-full flex flex-col gap-2 items-center`}>
                  <div className={`w-full flex flex-row items-center justify-between gap-2`}>
                    <h3 className={`text-lg font-righteous text-brandblue`}>Checklists to complete ({checkPeriodIdsInProgress.length})</h3>
                    <ExpandCollapseIcon
                      isExpanded={expandIncompleteChecklists}
                      setIsExpanded={setExpandIncompleteChecklists}
                    />
                  </div>
                  {expandIncompleteChecklists && <div className={`w-full flex flex-col gap-2`}>
                    {checkPeriodIdsInProgress.map((checklistPeriodId: any, index: number) => {
                      const thisChecklistPeriod = tableData.ChecklistPeriods[checklistPeriodId]
                      if (!thisChecklistPeriod) return null
                      const checklistId = thisChecklistPeriod.ChecklistId
                      const thisChecklist = tableData.Checklists[checklistId] || null
                      return <ChecklistSummary
                        key={index}
                        checklistId={checklistPeriodId.ChecklistId}
                        thisChecklist={thisChecklist}
                        checkPeriodId={checklistPeriodId}
                      />
                    })}
                  </div>}
                </div>}



              {checkPeriodIdsComplete.length > 0 &&
                <div className={`w-full flex flex-col gap-2 items-center`}>
                  <div className={`w-full flex flex-row items-center justify-between gap-2`}>
                    <h3 className={`text-lg font-righteous text-brandblue`}>Completed or closed checklists ({checkPeriodIdsComplete.length})</h3>
                    <ExpandCollapseIcon
                      isExpanded={expandCompleteChecklists}
                      setIsExpanded={setExpandCompleteChecklists}
                    />
                  </div>
                  {expandCompleteChecklists && <div className={`w-full flex flex-col gap-2`}>
                    {checkPeriodIdsComplete.map((checklistPeriodId: any, index: number) => {
                      const thisChecklistPeriod = tableData.ChecklistPeriods[checklistPeriodId]
                      if (!thisChecklistPeriod) return null
                      const checklistId = thisChecklistPeriod.ChecklistId
                      const thisChecklist = tableData.Checklists[checklistId] || null
                      return <ChecklistSummary
                        key={index}
                        checklistId={checklistPeriodId.ChecklistId}
                        thisChecklist={thisChecklist}
                        checkPeriodId={checklistPeriodId}
                      />
                    })}
                  </div>}
                </div>}

            </div>
            :
            <NoChecklists />
          }

        </div>
        :
        <Spinner><p>Loading...</p></Spinner>}


    </div>
  </div>
}
export default Dashboard